<template>
    <div class="page" :style="{'--styleColor': actInfo.color, backgroundImage:'url('+ actInfo.bg_other +')'}">
      <PageLoading v-if="loading"></PageLoading>
      <TipsWechat ref="child" v-if="platform==2"></TipsWechat>
      <TipsZonglan ref="child" v-if="platform==3"></TipsZonglan>
      <TipsHbrb ref="child" v-if="platform==4"></TipsHbrb>
      <div class="topBanner"></div>
      <div class="mainBox">
        <div class="video-container" v-if="!isArt">
          <div id="video" class="video" style="width: 100%;height:100%;"></div>
        </div>
        <!-- 图文课程：右上角环形倒计时 -->
         <div class="countdownBox" ref="countdownBox" v-if="isArt && countdown > 0" :style="{ left: dragPosition.left, top: dragPosition.top }" @mousedown="onDragStart" @touchstart="onDragStart">
          <div class="art-countdown">
            <svg class="countdown-ring" viewBox="0 0 40 40">
              <circle class="ring-bg" cx="20" cy="20" r="17" />
              <circle class="ring-fg" cx="20" cy="20" r="17" :style="ringStyle" />
            </svg>
            <span class="countdown-num">{{ countdown }}</span>          
          </div>
          <span class="countdown-text">得奖励</span>
         </div>
        
        <div class="title" v-show="infoData.title">{{infoData.title}}</div>
        <div class="author" v-show="infoData.origin">{{infoData.origin}}</div>
        <div class="content" v-html="infoData.content"></div>
        <NavBox :actInfo="actInfo" homePath="/list"></NavBox>
      </div>
      <LotteryBox v-if="actInfo.dis_btn && (actInfo.dis_btn.includes('cj'))" :lotteryid="Number(actInfo.bind_lotteryid)"></LotteryBox>
      <stat :actId="Number(learnid)" :actTitle="actInfo.title" :platform="Number(platform)" v-if="learnid"></stat>
    </div>
  </template>
  
  <script> 
  import {reqLessionInfo} from '@/api/index2.js'
  import {reqLessionsInfo, reqWatchTime, reqAddScore} from '@/api/learn' //静态接口
  import PageLoading from '@/components/PageLoading.vue'
  import TipsWechat from '@/components/TipsWechat.vue'
  import TipsZonglan from '@/components/TipsZonglan.vue'
  import TipsHbrb from '@/components/TipsHbrb.vue'
  import LotteryBox from '@/components/LotteryBox.vue'
  import NavBox from '@/components/NavBox.vue'
  import stat from '@/components/stat.vue'
  //分享设置
  import { wxShare } from '@/utils/wxshare-wes2.com.js'
  import zonglan from '@/utils/cp-zonglan.js'

  export default {
    name: 'showLession',
    components: {
      PageLoading, TipsWechat, TipsZonglan, TipsHbrb, LotteryBox, NavBox, stat
    },
    data () {
      return {
        platform:0, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
        loading:false,
        learnid:0,
        token:"",
        accountId:'',
        uniqueId:'',
        lessionid:0,
        infoData:[],
        listType:'1', // 课程类型：1视频 2图文
        countdown:0, // 图文课程倒计时剩余秒数
        countdownTotal:0, // 图文课程倒计时总秒数
        countdownTimer:null,
        dragPosition: { left: '', top: '' },
        isDragging: false,
        dragStartPos: { x: 0, y: 0 },
        shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
        shareTitle:"",
        shareDesc:"", 
        style:{},
      }
    },
    computed: {
      // 是否图文课程（type=2）
      isArt(){
        return Number(this.listType) === 2;
      },
      // 环形倒计时进度（剩余比例：满环→空环）
      ringStyle(){
        const circ = 2 * Math.PI * 17;
        const total = this.countdownTotal > 0 ? this.countdownTotal : 1;
        const remain = this.countdown > 0 ? this.countdown : 0;
        return {
          strokeDasharray: circ,
          strokeDashoffset: circ * (1 - remain / total)
        };
      }
    },
    created (){
      this.platform = this.$route.query.platform;
      this.learnid = this.$route.query.learnid;
      this.listType = this.$route.query.type || '1';
      if(this.$route.query.hasOwnProperty("id")){
        this.lessionid = this.$route.query.id;
      }else{
        this.$toast({
          icon: 'warning-o',
          message: "您访问的信息错误或不存在"
        });
      }
      this.token = this.$store.state.token;
      this.accountId = this.$store.state.accountId;
      this.uniqueId = this.$store.state.uniqueId;      
      this.accessid = this.$store.state.accessid;
      this.openid = this.$store.state.openid;
      this.shareImg = this.$store.state.actInfo.share_img;
      this.shareTitle = this.$store.state.actInfo.share_title;
      this.shareDesc = this.$store.state.actInfo.share_desc;
      this.actInfo = this.$store.state.actInfo;
    },
    mounted () {      
      this.getLession()  
      zonglan.pageShare(0,'',this.shareImg,this.shareTitle,this.shareDesc);
    },    
    beforeDestroy(){
      if(this.countdownTimer){
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    methods: {
        // 图文课程倒计时：按后台「学习规则-倒计时秒数」计时，结束后加分
        startArtCountdown(){
          // 学习分值为 0：不显示倒计时，也不加分
          if((Number(this.infoData.zscore) || 0) <= 0){
            return;
          }
          const total = Number(this.actInfo.art_countdown) || 0;
          if(total <= 0){
            // 未配置阅读时限（0 秒）：打开即加分
            this.setScore();
            return;
          }
          // 有阅读时限：先设定观看时间点，倒计时结束后再触发加分
          this.setLine();
          this.countdownTotal = total;
          this.countdown = total;
          this.$nextTick(() => {
            this.initCountdownPosition();
          });
          this.countdownTimer = setInterval(() => {
            this.countdown--;
            if(this.countdown <= 0){
              this.countdown = 0;
              clearInterval(this.countdownTimer);
              this.countdownTimer = null;
              this.setScore();
            }
          }, 1000);
        },
        // 初始化倒计时框位置（首次渲染后冻结为可拖动坐标）
        initCountdownPosition(){
          const el = this.$refs.countdownBox;
          if (!el) return;
          this.dragPosition = { left: el.offsetLeft + 'px', top: el.offsetTop + 'px' };
        },
        getClientPos(e){
          if (e.touches && e.touches.length > 0) {
            return { x: e.touches[0].clientX, y: e.touches[0].clientY };
          }
          return { x: e.clientX, y: e.clientY };
        },
        onDragStart(e){
          if (e.type !== 'touchstart') {
            e.preventDefault();
          }
          this.isDragging = true;
          const pos = this.getClientPos(e);
          this.dragStartPos = { x: pos.x, y: pos.y };

          const onMove = (ev) => {
            if (!this.isDragging) return;
            ev.preventDefault();
            const cur = this.getClientPos(ev);
            const dx = cur.x - this.dragStartPos.x;
            const dy = cur.y - this.dragStartPos.y;
            const el = this.$refs.countdownBox;
            const newLeft = el.offsetLeft + dx;
            const newTop = el.offsetTop + dy;
            this.dragPosition = {
              left: newLeft + 'px',
              top: newTop + 'px',
            };
            this.dragStartPos = { x: cur.x, y: cur.y };
          };

          const onEnd = () => {
            this.isDragging = false;
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onEnd);
            document.removeEventListener('touchmove', onMove);
            document.removeEventListener('touchend', onEnd);
          };

          document.addEventListener('mousemove', onMove);
          document.addEventListener('mouseup', onEnd);
          document.addEventListener('touchmove', onMove, { passive: false });
          document.addEventListener('touchend', onEnd);
        },
        getLession() {
          let data = {
              platform:this.platform, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
              learnid:this.learnid, 
              lessionid:this.lessionid
          }      
          if(this.platform == 2){               
              data.accessid = this.accessid;
              data.openid = this.openid;
          }
          if(this.platform == 3 || this.platform == 4){
              data.account_id = this.accountId;
              data.unique_id = this.uniqueId;
          }  
          reqLessionInfo(data).then(res => {
            if(res.code==200) {
              this.infoData = res.data;
              // 图文课程：环形倒计时；视频课程：加载播放器
              if(this.isArt){
                this.startArtCountdown();
              } else {
                this.loadCkplayer();
              }
            } else {
              this.$toast({
                  icon: 'warning-o',
                  message: res.msg
              });
            }
          }).catch(err => {
            console.log('err',err);
          })        
        },
        setLine(){
          let data = {
              platform:this.platform, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
              learnid:this.learnid, 
              lessionid:this.lessionid
          }      
          if(this.platform == 2){               
              data.accessid = this.accessid;
              data.openid = this.openid;
          }
          if(this.platform == 3 || this.platform == 4){
              data.account_id = this.accountId;
              data.unique_id = this.uniqueId;
          }  
          reqWatchTime(data).then(res => {
            if(res.code==200) {
              localStorage.setItem('isClick_'+this.lessionid+'_'+this.accountId,1);
            } else {
              this.$toast({
                  icon: 'warning-o',
                  message: res.msg
              });
            }
          }).catch(err => {
            console.log('err',err);
          })  
        },
        setScore(){
          // 学习分值为 0：不请求增加积分
          if((Number(this.infoData.zscore) || 0) <= 0){
            return;
          }
          let data = {
              platform:this.platform, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
              learnid:this.learnid, 
              lessionid:this.lessionid
          }      
          if(this.platform == 2){               
              data.accessid = this.accessid;
              data.openid = this.openid;
          }
          if(this.platform == 3 || this.platform == 4){
              data.account_id = this.accountId;
              data.unique_id = this.uniqueId;
          } 
          
          reqAddScore(data).then(res => {
            if(res.code==200) {
              //更新本地已观看数据
              let viewed = localStorage.getItem(this.learnid+'_viewed') || '';
              let status = viewed.split(',').includes(this.lessionid);
              if(!status){
                localStorage.setItem(this.learnid+'_viewed', viewed ? viewed + ',' + this.lessionid : this.lessionid);
              }
              this.$toast({
                  duration: 5000,
                  icon: 'success',
                  message: res.msg
              });

            } else {
              this.$toast({
                  icon: 'warning-o',
                  message: res.msg
              });
            }
          }).catch(err => {
            console.log('err',err);
          })  
   
        },
        loadCkplayer(){
            let seekTime = localStorage.getItem('lession_'+this.lessionid);
            seekTime = parseFloat(seekTime);
            console.log('seekTime',seekTime);
  ;
            let backrateOpen = false;
            if(this.actInfo.speed==1){
                backrateOpen = true;
            }

            let videoObject = {
                    container: '#video',//视频容器的ID
                    // video: 'https://video.hebnews.cn/asset/ff03be35e4fde9432fb91d2f10c9c50a/play_video/df633c7ec1410db752346a78ce6b2982_0.mp4',//视频地址
                    video: [
                            [this.infoData.video_st, 'video/mp4', '标清'],
                            [this.infoData.video_hd, 'video/mp4', '高清']
                        ],
                    volume: 0.8,//默认音量，范围0-1
                    poster: this.infoData.poster,//封面图片地址
                    autoplay: false,//是否自动播放
                    loop: false,//是否需要循环播放
                    rotate:0,//视频旋转角度
                    zoom:0,//默认缩放比例
                    live: false,//是否是直播
                    ad:null,//广告
                    backLive:false,//显示返回直播按钮
                    seek: seekTime,//默认需要跳转的秒数
                    next: null,//下一集按钮动作
                    loaded: '',//加载播放器后调用的函数
                    plug:'',//使用插件，目前支持hls.js:用于在pc端播放m3u8，flv.js:播放flv，mpegts.js：播放ts
                    duration:0,//如果强制使用点播，而视频里不存在总时间，可以手动指定
                    preview: null,//预览图片对象
                    prompt: null,//提示点功能
                    crossOrigin:'',//发送跨域信息，示例：Anonymous            
                    type:'',//视频类型
                    playbackrate: 1,//默认倍速
                    ended:null,//结束显示的内容
                    webFull:false,//是否启用页面全屏按钮，默认不启用
                    theatre:null,//是否启用剧场模式按钮，默认不启用
                    controls:false,//是否显示自带控制栏
                    rightBar:null,//是否开启右边控制栏
                    smallWindows:null,//是否启用小窗口模式
                    smallWindowsDrag:true,//小窗口开启时是否可以拖动
                    screenshot:false,//截图功能是否开启
                    timeScheduleAdjust:5,//是否可调节播放进度,0不启用，1是启用，2是只能前进（向右拖动），3是只能后退，4是只能前进但能回到第一次拖动时的位置，5是看过的地方可以随意拖动
                    logo:'',//logo
                    menu:null,//右键菜单
                    information:{//关于
                    'Load:':'{loadTime} second',
                    'Duration:':'{duration} second',
                    'Size:':'{videoWidth}x{videoHeight}',
                    'Volume:':'{volume}%',
                    'Sudio decoded:':'{audioDecodedByteCount} Byte',
                    'Video decoded:':'{videoDecodedByteCount} Byte'
                    },
                    track:null,//字幕
                    title:'',//视频标题
                    language:'',//语言包文件
                    barHideTime:500,//控制栏隐藏时间
                    playbackrateOpen:backrateOpen,//是否开启控制栏倍速选项
                    playbackrateList:[1,1.25,1.5,2],//倍速配置值
                    cookie:'lession_'+this.lessionid,//cookie名称，在同一域中请保持唯一
                    looked:'lession_watched_',
                    domain:null,//cookie保存域
                    cookiePath:'/',//cookie保存路径
                    documentFocusPause:false,//窗口失去焦点后暂停播放
                    mouseWheelVolume:2,//是否启用鼠标滚轮调节音量功能，0=不启用，1=启用，2=全屏时才启用
                    keyVolume:2//是否启用键盘控制音量调节，0=不启用，1=启用，2=全屏时才启用
                };
            this.player = new ckplayer(videoObject); //初始化播放器

            // //定位至播放时间且seek的状态为seeked后，再禁止拖动进度条
            let _this = this;            

            //监听到播放
            this.player.play(function () {
                console.log('监听到播放');

                var time = localStorage.getItem(videoObject.cookie);
                _this.player.vars('timeScheduleAdjust',1);                
                _this.player.seek(time);
                _this.player.seek(function(obj){
                  console.log(obj);
                  if(obj['state']==="seeked") {//设定记忆播放时间结束
                    _this.player.vars('timeScheduleAdjust',5);//禁止拖动
                  }		
                });

                if(!localStorage.getItem('isClick_'+_this.lessionid+'_'+_this.token)){
                  _this.setLine() //设置时间线
                }                
            });

            this.player.pause(function(){
              _this.player.vars('timeScheduleAdjust',5);//禁止拖动
            })

            //监听到播放结束
            this.player.ended(function(){
              console.log('监听到播放结束');
              if(parseInt(localStorage.getItem(videoObject.cookie))==parseInt(_this.player.duration())){
                //请求后端，验证是否符合观看规则并增加积分
                _this.setScore()
              }


            });
        }
    }
    
  }
  </script>
  
  <style lang="scss" scoped>
  .page{
  width: 750px;
  min-height: 1366px;
  font-size: 30px;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
    .mainBox{
      width: 750px;
      min-height: 1366px;
      background: #fff;
      padding-top: 5px;
    }
    .topBanner{
      width: 750px;
      height: 150px;
      img{
        width: 100%;
        height: auto;
        display: block;
      }
    }
    .title{
      width: 680px;
      height: auto;
      line-height:60px;
      font-size: 36px;
      margin: 0 auto;
      text-align: center;
      font-family: "宋体";
    }
    .author{
      width: 680px;
      height: auto;
      line-height:80px;
      margin: 0 auto;
      text-align: center;
      font-size: 26px;
      color: #4c4c4c;
      border-bottom: 3px solid #e2e2e2;
      font-family: "黑体";
    }
    .content{
      width: 680px;
      height: auto;
      line-height:40px;
      margin: 0 auto;
      text-align:left;
      font-size: 26px;
      color: #4c4c4c;
      padding-bottom: 120px;
      p,div{
        width: 100%;
      }
      img{
        width: 90%;
        height: auto;
        margin: 0 auto;
        display: block;
      }
    }
  }
  .video-container{
    width: 710px;
    height: 400px;
    margin: 20px auto;
  }
  // 图文课程环形倒计时（右上角）
  .countdownBox{
    position: fixed;
    right: 20px;
    top: 130px;
    width: 100px;
    height: 100px;
    z-index: 30;
    cursor: grab;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    animation: countdown-text-pulse 5s ease-in-out infinite;
    .art-countdown{
      width: 80px;
      height: 80px;
      z-index: 30;
      display: flex;
      align-items: center;
      justify-content: center;
      .countdown-ring{
        position: absolute;
        left: 10px;
        top: -2px;
        width: 80px;
        height: 80px;
        background: rgba(247, 247, 247, 0.5);
        border-radius: 80px;
      }
      .ring-bg{
        fill: none;
        stroke: rgba(0,0,0,0.12);
        stroke-width: 4;
      }
      .ring-fg{
        fill: none;
        stroke: var(--styleColor, #409eff);
        stroke-width: 4;
        stroke-linecap: round;
        transform: rotate(-90deg);
        transform-origin: 50% 50%;
        transition: stroke-dashoffset 1s linear;
      }
      .countdown-num{
        font-size: 32px;
        line-height: 1;
        text-align: center;
        font-weight: bold;
        color: var(--styleColor, #409eff);
        z-index: 99;
      }
      
    }
    .countdown-text{
      padding: 5px 10px;
      z-index: 30;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
      background: var(--styleColor, #409eff);
      border-radius: 10px;
      z-index: 99;
      margin-top: 5px;      
    }    
  }
  @keyframes countdown-text-pulse{
    0%, 12.5%, 25%, 100%{
      transform: scale(1);
    }
    6.25%, 18.75%{
      transform: scale(1.08);
    }
  }
  
  </style>